<template>
  <div class="basic-block block-lead-menu" :style="styles">
    <img v-if="targetInfo.leadMenu.deco" :src="targetInfo.leadMenu.deco" class="block-lead-menu__deco" alt="">
    <div class="content-wrap">
      <div class="block-lead-menu__inner">
        <div class="block-lead-menu__counselor">
          <img class="block-lead-menu__counselor-image" :src="targetInfo.leadMenu.counselorImage" alt="">
          <p class="block-lead-menu__comment" v-html="targetInfo.leadMenu.comment"></p>
        </div>
        <p class="block-lead-menu__lead" v-html="targetInfo.leadMenu.lead"></p>
        <!-- <lp-base-button label="もっと占ってみる" design="fill" :color-scheme="colorScheme" class="block-lead-menu__btn" @clicked="clicked" /> -->
      </div>
    </div>
  </div>
</template>

<script>
import LpBaseButton from '@/utvStore/components/recommend/lp/partials/LpBaseButton'

export default {
  name: 'BlockLeadMenu',
  components: {
    LpBaseButton,
  },
  props: {
    targetInfo: {
      type: Object,
      default(){
        return {}
      }
    },
    colorScheme: {
      type: Object,
      default(){
        return {}
      }
    },
    subscUrl: String,
  },
  computed:{
    styles(){
      return {
        '--key-color': this.colorScheme.keyColor,
        '--second': this.colorScheme.second,
        '--grad-start': this.colorScheme.gradStart,
        '--grad-end': this.colorScheme.gradEnd,
      }
    }
  },
  methods: {
    clicked() {
      location.href = this.subscUrl
    },
  },
}
</script>

<style scoped lang="scss">
@import "../../../../../../../../sass/commons/commonVariables.scss";

$l_col_keycolor: var(--key-color);
$l_col_second: var(--second);
$l_col_grad_start: var(--grad-start);
$l_col_grad_end: var(--grad-end);

.block-lead-menu {
  background: #FBF8F1;
  padding: 20px 0 24px;
  &__deco {
    position: absolute;
    top: -27px;
    left: 0;
    width: 17.6%;
    max-width: 80px;
    z-index: 2;
  }
  &__inner {
    padding: 0 20px;
  }
  &__counselor {
    display: flex;
    align-items: flex-end;
    margin: 0 0 16px;
  }
  &__counselor-image {
    flex: 0 1 auto;
    width: 38.3%;
    max-width: 140px;
    margin: 0 10px 0 0;
  }
  &__comment {
    flex: 1 1 auto;
    font-size: 16px;
    line-height: 20px;
    font-weight: bold;
    text-align: justify;
    background: $l_col_second;
    border-radius: 8px;
    padding: 32px 10px 35px;
    margin: 0;
    position: relative;
    &::after {
      content: '';
      position: absolute;
      top: 0;
      bottom: 0;
      right: calc(100% - 1px);
      margin: auto;
      width: 0;
      height: 0;
      border: 10px solid transparent;
      border-right-color: $l_col_second;
    }
    b {
      font-size: 16px;
    }
  }
  &__lead {
    font-weight: bold;
    font-size: 16px;
    line-height: 28px;
    text-align: center;
    letter-spacing: 1px;
    color: $l_col_keycolor;
    margin: 0 auto;
  }
  &__btn {
    max-width: 270px;
    margin: 0 auto;
  }
}
</style>



// WEBPACK FOOTER //
// ../../../../resources/assets/js/utvStore/components/recommend/lp/counselor/kanoucoco/blocks/BlockLeadMenu.vue